export const courseHref = (slug: string): string => `/courses/${encodeURIComponent(slug)}`

export const enrollHref = (slug?: string): string => slug ? `/enroll?course=${encodeURIComponent(slug)}` : '/enroll'
